import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as glossaire_affichage_type_capteur from '../../../../ressources/glossaires/glossaire_affichage_type_capteur';
import * as actions from '../../../../services/actions';
import DataGrid from '../../../UI/DataGrid/DataGrid';
import styles from './TableauSensorType.module.scss';

const COLUMN_CONFIG = [
  ['sensor_type_id', 'sensor_type_id', 100],
  ['sensor_type_name', 'sensor_type_name', 200],
  ['sensor_type_display', 'sensor_type_display', 130],
  ['sensor_type_path_image', 'sensor_type_path_image', 300],
];

const formatSensorTypeDisplay = (cell) => {
  switch (cell) {
    case glossaire_affichage_type_capteur.default_display:
      return checkMot('default');
    case glossaire_affichage_type_capteur.notify:
      return checkMot('notify');
    default:
      return checkMot('default');
  }
};

const createColumn = (field, labelKey, width) => {
  const baseColumn = {
    field,
    headerName: checkMot(labelKey),
    flex: 1,
    minWidth: width,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  };

  if (field === 'sensor_type_display') {
    return {
      ...baseColumn,
      renderCell: (params) => formatSensorTypeDisplay(params.value),
    };
  }

  return baseColumn;
};

const TableauSensorType = ({ selectioneLigne }) => {
  // Redux hooks
  const dispatch = useDispatch();
  const sensorTypesList = useSelector(
    (state) => state.capteur.sensor_types_list
  );

  const [selectionModel, setSelectionModel] = useState([]);

  // Columns definition
  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, labelKey, width]) =>
        createColumn(field, labelKey, width)
      ),
    []
  );

  // Effects
  useEffect(() => {
    dispatch(actions.reqRecupererListeSensorType());
  }, [dispatch]);

  const validRows = useMemo(
    () =>
      (sensorTypesList || []).filter(
        (row) => row.sensor_type_id !== null && row.sensor_type_id !== undefined
      ),
    [sensorTypesList]
  );

  // Handle row selection
  const handleSelectionModelChange = useCallback(
    (newSelection) => {
      setSelectionModel(newSelection);
      if (newSelection.length > 0) {
        const selectedRow = validRows.find(
          (row) => row.sensor_type_id === newSelection[0]
        );
        if (selectedRow) {
          selectioneLigne(selectedRow);
        }
      }
    },
    [selectioneLigne, validRows]
  );

  if (!validRows.length) {
    return null;
  }

  return (
    <div className={styles.Tableau}>
      <div className={styles.TableauBootstrap}>
        <DataGrid
          rows={validRows}
          columns={columns}
          getRowId={(row) => row.sensor_type_id}
          rowSelectionModel={selectionModel}
          onRowSelectionModelChange={handleSelectionModelChange}
          disableMultipleRowSelection
          className={styles.dataGrid}
        />
      </div>
    </div>
  );
};

export default TableauSensorType;
